import { type CustomCellEditorProps } from "ag-grid-react";
import { useCallback, useRef } from "react";

import { BTTextArea } from "commonComponents/btWrappers/BTTextArea/BTTextArea";

import "./MultiLineTextCellEditor.less";

export const MultiLineTextCellEditor = ({
    value,
    onValueChange,
    stopEditing,
}: CustomCellEditorProps<unknown, string>) => {
    const initialValueRef = useRef<string>(value ?? "");

    const handleKeyDown = useCallback(
        (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
            if (e.key === "Escape") {
                onValueChange?.(initialValueRef.current);
                stopEditing();
            } else if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                stopEditing();
            } else if (e.key === "Enter" && e.shiftKey) {
                e.stopPropagation();
            }
        },
        [onValueChange, stopEditing],
    );

    const handleFocus = useCallback((e: React.FocusEvent<HTMLTextAreaElement>) => {
        const target = e.target;
        target.setSelectionRange(target.value.length, target.value.length);
    }, []);

    return (
        <BTTextArea
            className="MultiLineTextCellEditor"
            id="multiLineTextCellEditor"
            data-testid="multiLineTextCellEditor"
            value={value ?? ""}
            onChange={(_id, newValue) => onValueChange?.(newValue)}
            onBlur={(_id, _touched, blurValue) => {
                if (blurValue !== undefined) {
                    onValueChange?.(blurValue);
                }
            }}
            onKeyDown={handleKeyDown}
            onFocus={handleFocus}
            minRows={3}
            maxRows={10}
            debouncingContext={{ useDebouncing: false }}
            blurOnChange={false}
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
        />
    );
};
